module.exports = __webpack_public_path__ + "static/media/ic_canvas_activate.9aeb901e.svg";